import Vue from 'vue';

export default Vue.component('smart-suggest-vendor-image', {
    template: `
    <div class="fl-as-vendor-image-container" v-if="imageUrl">
    <img :src="usedImageUrl" class="fl-as-vendor-image" @error="fallbackImage()" alt="vendor">
    </div>
  `,
    props: { imageUrl: String },
    watch: {
        imageUrl(newImageUrl: string): void {
            this.usedImageUrl = newImageUrl;
        },
    },
    data(): Record<string, any> {
        return {
            usedImageUrl: this.imageUrl,
        };
    },
    methods: {
        fallbackImage(): void {
            this.usedImageUrl = 'https://cdn.findologic.com/login.symfony/web/images/image_not_found.png';
        },
    },
});
